import {isClientEntityOperational} from "@common-core/coat-operational-hierarchy-appsync-model";
import {CreatePlanNode, CreatePlanSummary} from "../view-model";

export const summarizePlan = (node: CreatePlanNode): CreatePlanSummary => {
  const operational = isClientEntityOperational(node.source);
  return node.children.map(summarizePlan).reduce(
    (accumulator, summary) => ({
      creating: [...accumulator.creating, ...summary.creating],
      existing: [...accumulator.existing, ...summary.existing]
    }),
    {
      creating: node.selected && !operational ? [node] : [],
      existing: node.selected && operational ? [node] : []
    }
  );
};
